import { faqData } from "@/mocks/homeData";

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wide">FAQ</span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mt-2 font-heading">常见问题解答</h2>
          <p className="text-sm text-foreground-600 mt-2">关于51吃瓜网站的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden" open={i === 0}>
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4 font-heading">{item.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-100 flex items-center justify-center group-open:bg-accent-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-accent-600 text-sm transition-transform group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}